import './App.css'

import { PlaylistWidget } from './features/widget/PlaylistWidget'
import { Route, Routes } from 'react-router-dom'
import { ArticleWidget } from './features/widget/ArticleWidget'
import { useAppDispatch, useAppSelector } from './app/hooks'
import {
    resetArticleStorage,
    selectAllArticles,
    selectPlayedArticleTimestamp,
} from './features/article/data/articleSlice'
import { useEffect } from 'react'
import { isOver14Days } from './shared/utils/basic'
import { resetQueueStorage, setSuggestedArticles } from './features/queue/queueSlice'

function AppRoutes() {
    const dispatch = useAppDispatch()

    const lastPlayedArticleTimestamp = useAppSelector(selectPlayedArticleTimestamp)
    const articles = useAppSelector(selectAllArticles)

    useEffect(() => {
        if (lastPlayedArticleTimestamp) {
            if (isOver14Days(lastPlayedArticleTimestamp)) {
                dispatch(resetArticleStorage())
                dispatch(resetQueueStorage())
                dispatch(setSuggestedArticles(articles))
            }
        }
    }, [lastPlayedArticleTimestamp])

    return (
        <Routes>
            <Route path='/v1' element={<PlaylistWidget />} />
            <Route path='/v1/article' element={<ArticleWidget />} />
            <Route path='/v1/playlist' element={<PlaylistWidget />} />
        </Routes>
    )
}

export default AppRoutes
